<template>
  <QuestionBase :question="question" :errors="[...serverErrors, ...jsErrors]" :valid="data !== null">
    <InputRadio
        v-model="data"
        :options="booleanYesNo"
        :db="db"
        :args="args"
        :skipped="skipped"
        @skipped="skipped=$event"
        @serverErrors="serverErrors=$event"
        @jsErrors="jsErrors=$event"
    />
  </QuestionBase>
</template>

<script>
import { willRelationshipHelpers } from "../../../../fieldsets/will/helpers/willRelationshipHelpers";
import { willPeopleHelpers } from "../../../../fieldsets/will/helpers/willPeopleHelpers";
import { questionLoadHelpers } from "../../../helpers/questionLoadHelpers";
import { general } from "../../../options/general";

import QuestionBase from "../../../QuestionBase";
import InputRadio from "../../../inputs/InputRadio";

export default {
  name: 'PartnerPrimaryYN',
  mixins: [general, questionLoadHelpers, willPeopleHelpers, willRelationshipHelpers],
  components: {
    InputRadio,
    QuestionBase
  },
  props: {
    value: {
      type: [Boolean],
      required: false
    },
    callbackFunction: {
      type: Function,
      required: true
    }
  },
  computed: {
    data: {
      set(value) {
        this.$emit('input', value)
      },
      get () {
        return this.value
      }
    },
    question() {
      return {
        title: `Do you want to name ${this.partner.name_first} ${this.partner.name_last} as your main trustee?`,
        subTitle: `It is common to have your partner or spouse named as the main trustee. You can then name 'secondary trustees' who will step in should ${this.partner.name_first} ${this.partner.name_last} pass away before you.`,
        tip: null,
      }
    }
  },
  data () {
    return {
      db: {
        saveLocation: 'product_will_data',
        saveField: 'primaryPartnerTrustees',
        formPath: 'data.trustees.details.primaryPartner',
        jsonSaveField: 'primaryPartner',
        callbackFunction: this.callbackFunction
      },
      args: {
        skippable: false,
        required: true,
      },
      serverErrors: [],
      jsErrors: [],
      skipped: false,
    }
  }
}
</script>
